import { Either } from "@jawbreaker/either";
export var getElements = function (parentRef, currentPos) {
    var parent = parentRef.current;
    if (parent === null)
        return Either.left("Parent is null");
    var children = Array.from(parent.children).filter(isHTMLElement);
    if (children.length <= 0)
        return Either.left("Parent is missing children");
    var first = children[0];
    if (first === null)
        return Either.left("First child is null");
    var last = children[children.length - 1];
    if (last === null)
        return Either.left("Last child is null");
    var goTo = currentPos ? children[currentPos] : undefined;
    return Either.right({
        parent: parent,
        children: children,
        first: first,
        last: last,
        goTo: goTo,
    });
};
var isHTMLElement = function (element) {
    return element instanceof HTMLElement;
};
